import React from 'react';
import PropTypes from 'prop-types';
import { map, uniq } from 'lodash';

import Money from '../../../../common/money';

const TaxCell = ({ value }) => (
  <React.Fragment>
    {
      value.map(tax => (
        <React.Fragment key={tax}>
          {tax} <br />
        </React.Fragment>
      ))
    }
  </React.Fragment>
);

TaxCell.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const columns = {
  name: {
    Header: 'Name',
    accessor: 'name',
  },
  price: {
    Header: 'Price',
    accessor: 'price',
    Cell: ({ value }) => <Money>{value}</Money>, // eslint-disable-line react/prop-types
  },
  supplyPrice: {
    Header: 'Supply Price',
    accessor: 'supplyPrice',
    Cell: ({ value }) => <Money>{value}</Money>, // eslint-disable-line react/prop-types
  },
  shops: {
    Header: 'Shops',
    id: 'shops',
    accessor: (data) => {
      const { assignments = [] } = data;
      return `${assignments.length} shop${assignments.length > 1 ? 's' : ''}`;
    },
  },
  inventory: {
    Header: 'Current Inv.',
    accessor: 'inventory',
  },
  totalInventory: {
    Header: 'Total Inv.',
    id: 'totalInventory',
    accessor: 'totalInventory',
  },
  unallocatedInventory: {
    Header: 'Unallocated Inv.',
    accessor: 'inventory',
  },
  lowInventory: {
    Header: 'Low Inv.',
    id: 'lowInventoryThreshold',
    accessor: (data) => {
      const { assignments, lowInventoryThreshold } = data;
      const variants = uniq([lowInventoryThreshold, ...map(assignments || [], shop => shop.lowInventoryThreshold)]);
      return variants.length > 1 ? 'Varies' : variants[0];
    },
  },
  highInventory: {
    Header: 'High Inv.',
    id: 'highInventoryThreshold',
    accessor: (data) => {
      const { assignments, highInventoryThreshold } = data;
      const variants = uniq([highInventoryThreshold, ...map(assignments || [], shop => shop.highInventoryThreshold)]);
      return variants.length > 1 ? 'Varies' : variants[0];
    },
  },
  sku: {
    Header: 'SKU',
    accessor: 'sku',
  },
  tax: {
    Header: 'Tax',
    accessor: 'tax',
    Cell: TaxCell,
  },
  category: {
    Header: 'Category',
    accessor: 'category',
  },
  brand: {
    Header: 'Brand',
    accessor: 'brand',
  },
};

export default columns;
